import React from 'react';
import PropTypes from 'prop-types';
import { Message, Icon } from 'semantic-ui-react';
import { ReactTypeformEmbed } from 'react-typeform-embed';
import { compose } from 'recompose';

import hasUserInfo from '../../hocs/has-user-info';
import hasOrganisation from '../../hocs/has-organisation';

const TYPEFORM_URL = 'https://8i5i40bh5gd.typeform.com/to/uTvp2XTe';


const centerStyle = {
  width: 600, margin: '200px auto',
};

const EntrySurvey = ({ userInfo, organisation }) => {
  let specificTypeFormUrl;

  if (userInfo && organisation) {
    const name = encodeURIComponent(userInfo.name);
    const email = encodeURIComponent(userInfo.email);
    const orgName = encodeURIComponent(organisation.name);
    specificTypeFormUrl = `${TYPEFORM_URL}?user_name=${name}&user_email=${email}&organisation_name=${orgName}`;
  }

  return (
    <div className="page">
      <div className="page-content">
        <Message icon info style={centerStyle}>
          <Icon name="circle notched" loading />
          <Message.Content>
            <Message.Header>loading entry survey</Message.Header>
          please wait while we prepare our short survey...
          </Message.Content>
        </Message>
        {
          userInfo && organisation &&
          <ReactTypeformEmbed url={specificTypeFormUrl} />
        }
      </div>
    </div>
  );
};

EntrySurvey.propTypes = {
  userInfo: PropTypes.object.isRequired,
  organisation: PropTypes.object.isRequired,
};

export default compose(
  hasUserInfo,
  hasOrganisation,
)(EntrySurvey);



/** WEBPACK FOOTER **
 ** ./src/containers/entry-survey/index.js
 **/